import React from 'react';
import InfoModal from '../../../../../components/data-display/InfoModal';
import Paragraph from '../../../../../components/common/Paragraph';

const FatcaModal = () => (
  <InfoModal
    buttonLabel="Sobre Declaración FATCA"
    title="Declaración FATCA"
    width={780}
    buttonProps={{ style: { marginTop: '-5px' } }}
  >
    <Paragraph align="justify">
      Por el presente instrumento, en mi calidad de Cliente de Vantrust Capital Corredores de la
      Bolsa S.A. declaro que conozco expresamente las normas establecidas en el &quot;Foreign
      Account Tax Compliance Act&quot;, en adelante FATCA, dictada por el Gobierno de los Estados
      Unidos de Ámerica, donde se entiende por &quot;US PERSON&quot;, toda persona que:
    </Paragraph>
    <ol style={{ listStyleType: 'upper-roman' }}>
      <li>
        Tenga nacionalidad estadounidense, a pesar de no residir en Estados Unidos de América;
      </li>
      <li>Que posea pasaporte emitido por Estados Unidos de América;</li>
      <li>Que haya nacido en Estados Unidos de América;</li>
      <li>Que sea residente permanente de Estados Unidos de América;</li>
      <li>
        Que sea sujeto fiscal de Estados Unidos de América, esto es: (I) En el presente año haya
        permanecido al menos 183 días en Estados Unidos de América; (II) Respecto al año pasado haya
        permanecido al menos cuatro meses en Estados Unidos de América; (III) Respecto al año
        antepasado haya permanecido al menos dos meses en Estados Unidos de América.
      </li>
    </ol>
    <Paragraph align="justify">
      Por su parte, en su caso, el Cliente autoriza expresamente a Vantrust Capital Corredores de
      Bolsa S.A. a entregar información cuando sea requerida por la autoridad compentente en Estados
      Unidos (IRS), en conformidad con FATCA y con todas aquellas leyes similares existentes o que
      se dicen en el futuro. Adicionalmente, el Cliente declara que se obliga a informar a Vantrust
      Capital Corredores de Bolsa S.A. tan pronto tome conocimiento, del hecho de haber adquirido la
      calidad de US PERSON, o bien, haya dejado de ser US PERSON, por cualquier motivo, liberando a
      Vantrust Capital Corredores de Bolsa S.A. de cualquier responsabilidad respecto a la normativa
      tributaria de Estados Unidos de América.
    </Paragraph>
  </InfoModal>
);

export default FatcaModal;
